import React from 'react'
import styled from 'styled-components'
import { BlockNumber } from './BlockNumber'
import { Version } from './Version'
import {
  Colors,
  DEFI_PULSE_URL,
  DISCORD_URL,
  Fonts,
  FontWeights,
  GITBOOK_URL,
  GITHUB_URL,
  INTEGRAL_ABOUT_URL,
  INTEGRAL_CAREERS_URL,
  INTEGRAL_DOCS_URL,
  INTEGRAL_PRIVACY_URL,
  INTEGRAL_SUPPORT_URL,
  INTEGRAL_TERMS_URL,
  INTEGRAL_TOKEN_URL,
  TWITTER_URL,
} from '../../constants'
import { DefiPulse, Discord, GitBook, Github, Twitter } from '../icons'

export function Footer() {
  return (
    <Bar>
      <Above>
        <Intro>
          Integral is the world’s 1st DeFi primitive for large orders. It is developed and maintained by JeyLabs.
        </Intro>
        <Links>
          <li>
            <a href="https://pre1559.integral.link/" target="_blank">
              <Pre1559>
                <em>Having wallet issues after London Hardfork (EIP-1559)?</em>
                Try our legacy interface
              </Pre1559>
            </a>
          </li>
          <li>
            <a href={INTEGRAL_ABOUT_URL} target="_blank">
              About
            </a>
          </li>
          <li>
            <a href={INTEGRAL_DOCS_URL} target="_blank">
              Docs
            </a>
          </li>
          <li>
            <a href={INTEGRAL_TOKEN_URL} target="_blank">
              Token
            </a>
          </li>
          <li>
            <a href={INTEGRAL_SUPPORT_URL} target="_blank">
              Support
            </a>
          </li>
          <li>
            <a href={INTEGRAL_CAREERS_URL} target="_blank">
              Careers
            </a>
          </li>
          <li>
            <a href={INTEGRAL_TERMS_URL} target="_blank">
              Terms of Use
            </a>
          </li>
          <li>
            <a href={INTEGRAL_PRIVACY_URL} target="_blank">
              Privacy Policy
            </a>
          </li>
        </Links>
        <Social>
          <p>
            <Emoji>⚔️</Emoji> Join the Resistance
          </p>
          <ul>
            <li>
              <a href={DEFI_PULSE_URL} target="_blank" title="DefiPulse">
                <DefiPulse />
              </a>
            </li>
            <li>
              <a href={TWITTER_URL} target="_blank" title="Twitter">
                <Twitter />
              </a>
            </li>
            <li>
              <a href={DISCORD_URL} target="_blank" title="Discord">
                <Discord />
              </a>
            </li>
            <li>
              <a href={GITBOOK_URL} target="_blank" title="GitBook">
                <GitBook />
              </a>
            </li>
            <li>
              <a href={GITHUB_URL} target="_blank" title="GitHub">
                <Github />
              </a>
            </li>
          </ul>
        </Social>
      </Above>
      <Below>
        <Version />
        <BlockNumber />
      </Below>
    </Bar>
  )
}

const Bar = styled.footer`
  position: relative;
  color: ${Colors.Black};
  font-size: 13px;
  background: rgb(242, 242, 242);
  background: linear-gradient(0deg, rgba(242, 242, 242, 1) 0%, rgba(239, 239, 239, 1) 100%);

  @media (max-width: 1024px) {
    padding-bottom: 54px;
  }
`

const Above = styled.div`
  padding: 40px 24px 60px 24px;
  display: flex;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

const Intro = styled.p`
  margin: 0 50px 0 0;
  padding: 0;
  max-width: 250px;
  font-family: ${Fonts.Header};
  line-height: 2;

  @media (max-width: 768px) {
    margin: 0;
    flex-basis: 50%;
  }
`

const Links = styled.ul`
  margin: 0;
  padding: 3px 0 0 0;
  list-style: none;

  li {
    margin-top: 15px;

    &:first-child {
      margin-top: 0;
    }
  }

  a {
    color: ${Colors.Black};
    font-size: 12px;
    font-weight: ${FontWeights.Bold};
    text-decoration: none;
    text-transform: uppercase;

    &:hover {
      color: ${Colors.Hover};
    }
  }

  @media (max-width: 768px) {
    flex-basis: 50%;
    text-align: right;
  }
`

const Social = styled.ul`
  margin: 0 0 auto auto;
  align-self: flex-end;

  p {
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${Fonts.Header};
  }

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    justify-content: flex-end;
  }

  li {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }

  a {
    color: ${Colors.Black};

    svg {
      width: 22px;
      height: 22px;
    }
  }

  @media (max-width: 768px) {
    margin-top: 30px;
  }
`

const Emoji = styled.span`
  margin-right: 5px;
  font-size: 18px;
`

const Below = styled.div`
  padding: 10px 24px;
  display: flex;
  color: ${Colors.DarkGray};
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${Colors.DarkerGray};
`

const Pre1559 = styled.span`
  margin-bottom: 30px;
  display: block;
  max-width: 250px;

  em {
    margin-bottom: 5px;
    display: block;
    font-weight: ${FontWeights.Regular};
    text-transform: none;
  }
`
